<template>
  <div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>游戏管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="operating">
      <span> <el-button type="primary" size="small" @click="addDialog()" >新增游戏</el-button></span>
    </div>
    <div >
      <template>
        <el-table
          :data="tableData"
          stripe
          center
          border
          highlight-current-row
          @filter-change="filterStatusHandler"
          style="width: 100%">
          <el-table-column
            align="center"
            label="排序"
            width="80">
            <template slot-scope="scope">
              <el-input  size="small" v-model="scope.row.sort" @change="changeSort(scope.row)" :min="0" :max="1000" label="描述文字"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="name"
            label="游戏名称">
          </el-table-column>
          <el-table-column
            align="center"
            label="游戏图标">
            <template slot-scope="scope">
              <el-image :src="scope.row.icon_img" alt="" style="height: 40px; width: 40px">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="type_list"
            label="游戏标签"
            column-key="type_ids"
            filter-multiple
            :filters=filterTypesRule>
          </el-table-column>
          <el-table-column
            align="center"
            label="上架状态">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.is_shelves?'上架':'下架'" placement="top">
                <el-switch
                  v-model="scope.row.is_shelves"
                  @change="handleChangeStatus(scope.row, 'shelves_status','is_shelves')"
                  active-color="#13ce66"
                  inactive-color="#DCDFE6">
                </el-switch>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="官网首页显示">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.is_home?'显示':'不显示'" placement="top">
                <el-switch
                  v-model="scope.row.is_home"
                  @change="handleChangeStatus(scope.row, 'home_display','is_home')"
                  active-color="#13ce66"
                  inactive-color="#DCDFE6">
                </el-switch>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="游戏推荐显示">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.is_recommend?'显示':'不显示'" placement="top">
                <el-switch
                  v-model="scope.row.is_recommend"
                  @change="handleChangeStatus(scope.row, 'recommend_display','is_recommend')"
                  active-color="#13ce66"
                  inactive-color="#DCDFE6">
                </el-switch>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="编辑内容"
            width="240">
            <template slot-scope="scope" >
              <el-button
                type="primary"
                size="small"
                @click="editDialog(scope.row)">信息</el-button>
              <el-button
                type="primary" size="small"  @click="imgDialog(scope.row)">图片</el-button>
              <el-button
                type="primary" size="small" @click="linkDialog(scope.row)">链接</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block page-box">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page=page
            :page-sizes="[50, 100, 200, 500]"
            :page-size=page_size
            layout="total, sizes, prev, pager, next, jumper"
            :total=total>
          </el-pagination>
        </div>
      </template>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogInfoVisible" :close-on-click-modal="false" width="640px" class="padding_10">
      <el-form :model="addForm" label-width="80px" :rules="infoRules" ref="addForm">
        <el-form-item label="游戏名称" prop="name" >
          <el-input v-model="addForm.name" auto-complete="off" placeholder="请输入游戏名称"></el-input>
        </el-form-item>
        <el-form-item label="游戏分级" prop="systematics" >
          <el-select v-model="addForm.systematics" placeholder="请选择游戏分级" style="width: 100%">
            <el-option
              v-for="item in systematicsOption"
              :key="item.value"
              :label="item.text"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="游戏标语" prop="slogan" >
          <el-input v-model="addForm.slogan" auto-complete="off" placeholder="请输入游戏标语"></el-input>
        </el-form-item>
        <el-form-item label="游戏描述" prop="desc" >
          <el-input v-model="addForm.desc" auto-complete="off" placeholder="请输入游戏描述"></el-input>
        </el-form-item>
        <el-form-item label="游戏类型" prop="type_list" style="text-align: left;">
          <el-checkbox-group v-model="addForm.type_list" >
            <el-checkbox
              v-for="type in typeList"
              :label="type.id"
              :key="type.id" class="padding_10 line-height margin-right-10">
              {{type.type_name}}
            </el-checkbox>
            <el-checkbox
              :label="new_type.id"
              :key="new_type.id"
              disabled
              style="margin-left: 16px"
              :checked="typeName!== ''"
            >
              <template>
                其他 <el-input v-model="typeName" @blur="addType" size="mini" style="width: 80%;" auto-complete="off" placeholder="请输入游戏类型"></el-input>
              </template>
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="支付方式" prop="pay_list" style="text-align: left;">
          <el-checkbox-group v-model="addForm.pay_list" >
            <el-checkbox
              v-for="pay in payList"
              :label="pay.id"
              :key="pay.id"
              border
              class="padding_10 line-height information-title margin-right-10">
              <template>
                <div style="text-align: center!important;width: 75px" >
                  <el-image
                    style="width: 48px; height: 24px;"
                    :src="pay.icon"
                    fit="contain"></el-image>
                </div>
                <div>
                  <span>{{pay.name}}</span>
                </div>
              </template>
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" :loading="addLoading" @click="addGame('addForm')">保 存</el-button>
        <el-button  size="small" @click="callOf('addForm')">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="dialogTitle" :visible.sync="dialogEditInfoVisible" :close-on-click-modal="false" width="600px" class="padding_10">
      <el-form :model="editForm" label-width="80px" :rules="infoRules" ref="editForm">
        <el-form-item label="游戏名称" prop="name" >
          <el-input v-model="editForm.name" auto-complete="off" placeholder="请输入游戏名称"></el-input>
        </el-form-item>
        <el-form-item label="游戏分级" prop="systematics" >
          <el-select v-model="editForm.systematics" placeholder="请选择游戏分级" style="width: 100%">
            <el-option
              v-for="item in systematicsOption"
              :key="item.value"
              :label="item.text"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="游戏标语" prop="slogan" >
          <el-input v-model="editForm.slogan" auto-complete="off" placeholder="请输入游戏标语"></el-input>
        </el-form-item>
        <el-form-item label="游戏描述" prop="desc" >
          <el-input v-model="editForm.desc" auto-complete="off" placeholder="请输入游戏描述"></el-input>
        </el-form-item>
        <el-form-item label="游戏类型" prop="type_list" style="text-align: left;">
          <el-checkbox-group v-model="editForm.type_list" >
            <el-checkbox
              v-for="type in typeList"
              :label="type.id"
              :key="type.id" class="padding_10 line-height margin-right-10">
              {{type.type_name}}
            </el-checkbox>
            <el-checkbox
              :label="new_type.id"
              :key="new_type.id"
              style="margin-left: 16px"
              :checked="typeName!== ''"
              disabled
            >
              <template>
                其他 <el-input v-model="typeName" @blur="addType" size="mini" style="width: 80%;" auto-complete="off" placeholder="请输入游戏类型"></el-input>
              </template>
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="支付方式" prop="pay_list" style="text-align: left;">
          <el-checkbox-group v-model="editForm.pay_list" >
            <el-checkbox
              v-for="pay in payList"
              :label="pay.id"
              :key="pay.id"
              border
              class="padding_10 line-height information-title margin-right-10">
              <template>
                <div style="text-align: center!important;width: 75px" >
                  <el-image
                    style="width: 48px; height: 24px;"
                    :src="pay.icon"
                    fit="contain"></el-image>
                </div>
                <div>
                  <span>{{pay.name}}</span>
                </div>
              </template>
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary"  size="small" :loading="infoLoading" @click="editInfo('editForm')">保 存</el-button>
        <el-button size="small" @click="callOf('editForm')">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="dialogTitle" :visible.sync="dialogLinkVisible" :close-on-click-modal="false" width="600px" class="padding_10">
      <el-form :model="linkForm" label-width="140px" :rules="linkRules" ref="linkForm">
        <el-form-item label="游戏跳转链接" prop="game_url" >
          <el-input v-model="linkForm.game_url" auto-complete="off" placeholder="官网或预约链接"></el-input>
        </el-form-item>
        <el-form-item label="IOS下载链接" prop="ios_url" >
          <el-input v-model="linkForm.ios_url" auto-complete="off" placeholder="预约游戏可不填"></el-input>
        </el-form-item>
        <el-form-item label="安卓下载链接" prop="android_url" >
          <el-input v-model="linkForm.android_url" auto-complete="off" placeholder="预约游戏可不填"></el-input>
        </el-form-item>
        <el-form-item label="APK下载链接" prop="apk_url" >
          <el-input v-model="linkForm.apk_url" auto-complete="off" placeholder="预约游戏可不填"></el-input>
        </el-form-item>
        <el-form-item label="Facebook粉丝页" prop="fb_fans_url" >
          <el-input v-model="linkForm.fb_fans_url" auto-complete="off" placeholder="预约游戏可不填"></el-input>
        </el-form-item>
        <el-form-item label="MainAppId" prop="appid" >
          <el-input v-model="linkForm.appid" auto-complete="off" placeholder="请输入MainAppId"></el-input>
        </el-form-item>
        <el-form-item label="AppId" prop="display_appid" >
          <el-input v-model="linkForm.display_appid" auto-complete="off" placeholder="多个用逗号隔开"></el-input>
        </el-form-item>
        <el-form-item label="游戏信息接口" prop="game_info_url" >
          <el-input v-model="linkForm.game_info_url" auto-complete="off" placeholder="请输入游戏信息接口"></el-input>
        </el-form-item>
        <el-form-item label="储值信息接口" prop="pay_info_url" >
          <el-input v-model="linkForm.pay_info_url" auto-complete="off" placeholder="请输入储值信息接口"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" :loading="linkLoading" @click="setLink('linkForm')">保 存</el-button>
        <el-button size="small" @click="callOf('linkForm')">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="dialogTitle" :visible.sync="dialogImgVisible" :close-on-click-modal="false" width="640px" class="padding_10">
      <el-row :gutter="21">
        <el-col :span="8">
          <span><span style="color: red">*</span>游戏图标<span style="color: red;margin-left: 10px">128*128px</span></span>
          <div style="margin-top: 10px">
            <el-upload
              action="#"
              list-type="picture-card"
              :before-upload="beforeAvatarUpload"
              :on-change="handleIconChange"
              :http-request="submitUpload"
              :auto-upload="true"
              accept=".jpg,.png,.jpeg"
              :show-file-list="false"
              ref="icon">
              <img  v-if="imgInfo.icon_img" :src="imgInfo.icon_img"   class="height-140 margin-top-2 width-140">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-col>
        <el-col :span="8">
          <span><span style="color: red">*</span>游戏中心宣传图<span style="color: red;margin-left: 10px">317*210px</span></span>
          <div style="margin-top: 10px;">
            <el-upload
              action="#"
              list-type="picture-card"
              :before-upload="beforeAvatarUpload"
              :on-change="handleCenterChange"
              :http-request="submitUpload"
              :auto-upload="true"
              accept=".jpg,.png,.jpeg"
              :show-file-list="false"
              ref="center">
              <img v-if="imgInfo.center_img" :src="imgInfo.center_img"  class="width-140 margin-top-2 height-140">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-col>
        <el-col :span="8">
          <span >首页宣传图<span style="color: red;margin-left: 10px">295*412px</span></span>
          <div style="margin-top: 10px">
            <el-upload
              action="#"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :on-change="handleHomeChange"
              :http-request="submitUpload"
              accept=".jpg,.png,.jpeg"
              :auto-upload="true"
              list-type="picture-card"
              ref="home">
              <img v-if="imgInfo.home_img" :src="imgInfo.home_img"   class="height-140 margin-top-2 width-140">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" :loading="imgLoading" @click="setImg()">保 存</el-button>
        <el-button size="small" @click="callOf('')">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style src="../../assets/scss/game.css"></style>
<script>
import {
  getList,
  getTypeList,
  changeStatus,
  addTypeName,
  addGame,
  storeSort,
  getInfo,
  editInfo,
  getLinkInfo,
  editLink,
  getImgInfo,
  saveGameImg,
  getPayList
} from '../../api/game'
import {uploadImg} from '../../api'
export default {
  data () {
    return {
      imgLoading: false,
      addLoading: false,
      linkLoading: false,
      infoLoading: false,
      dialogInfoVisible: false,
      dialogEditInfoVisible: false,
      dialogLinkVisible: false,
      dialogImgVisible: false,
      tableData: [],
      systematicsOption: [
        {text: '12+', value: 1},
        {text: '15+', value: 2}
      ],
      new_type: {
        id: 0,
        type_name: ''
      },
      imgForm: {
        id: 0,
        icon_file_id: '',
        center_file_id: '',
        home_file_id: ''
      },
      iconFile: {},
      centerFile: {},
      homeFile: {},
      imgInfo: {
        id: 0,
        icon_img: '',
        center_img: '',
        home_img: ''
      },
      filterTypesRule: [],
      typeList: [],
      typeName: '',
      payList: [],
      dialogTitle: '',
      addForm: {
        name: '',
        slogan: '',
        desc: '',
        type_list: [],
        pay_list: [],
        systematics: ''
      },
      linkForm: {
        id: 0,
        game_url: '',
        ios_url: '',
        android_url: '',
        apk_url: '',
        fb_fans_url: '',
        appid: '',
        display_appid: '',
        game_info_url: '',
        pay_info_url: ''
      },
      editForm: {
        id: 0,
        name: '',
        slogan: '',
        desc: '',
        type_list: [],
        pay_list: [],
        systematics: ''
      },
      page: 1,
      page_size: 50,
      total: 0,
      curr_click_upload_tag: '',
      infoRules: {
        name: [
          { required: true, message: '请输入游戏名称', trigger: 'blur' }
        ],
        pay_list: [
          { required: true, message: '请选择支付方式', trigger: 'change' }
        ],
        systematics: [
          { required: true, message: '请选择游戏分级', trigger: 'change' }
        ]
      },
      linkRules: {
        game_url: [
          { required: true, message: '请输入游戏跳转链接', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    // 页面数据初始化表格数据
    this.setTableData()
    this.setTypeList()
    this.setPayList()
  },
  methods: {
    // 表格填充
    setTableData () {
      getList({
        page: this.page,
        page_size: this.page_size,
        type_ids: this.type_ids
      }).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.tableData = res.data.table_list
          this.total = res.data.total
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 设置类型过滤内容
    setTypeList () {
      getTypeList().then(res => {
        let {status, message} = res
        if (status === 2000) {
          let result = res.data
          this.typeList = result
          for (let i of result) {
            this.filterTypesRule.push({text: i.type_name, value: i.id})
          }
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 设置支付方式
    setPayList () {
      getPayList().then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.payList = res.data
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 关闭弹窗
    callOf (formName) {
      if (formName === 'addForm') {
        this.dialogInfoVisible = false
      } else if (formName === 'editForm') {
        this.dialogEditInfoVisible = false
      } else if (formName === 'linkForm') {
        this.dialogLinkVisible = false
      } else {
        this.dialogImgVisible = false
      }
      if (formName) {
        this.$refs[formName].resetFields()
      }
    },
    // 打开添加弹窗
    addDialog () {
      this.dialogInfoVisible = true
      this.dialogTitle = '添加游戏'
    },
    // 打开编辑弹窗
    editDialog (row) {
      this.dialogEditInfoVisible = true
      this.editForm.id = row.id
      this.typeName = ''
      this.dialogTitle = '游戏信息'
      // 获取游戏数据
      getInfo({
        id: row.id
      }).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.editForm = res.data
          this.editForm.id = row.id
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 修改游戏信息
    editInfo (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.infoLoading = true
          const storeData = this.editForm
          editInfo(storeData).then(res => {
            let {status, message} = res
            if (status === 2000) {
              this.$notify({
                message: message,
                type: 'success',
                offset: 100,
                showClose: false
              })
              this.setTableData()
              this.dialogEditInfoVisible = false
              this.typeName = ''
              this.new_type.id = 0
              this.setTypeList()
              this.$refs[formName].resetFields()
            } else {
              this.$notify({
                message: message,
                type: 'warning',
                offset: 100,
                showClose: false
              })
            }
            this.infoLoading = false
          })
        }
      })
    },
    // 分页大小切换回调
    handleSizeChange (val) {
      this.page_size = val
      this.setTableData()
    },

    // 页码切换回调
    handleCurrentChange (val) {
      this.page = val
      this.setTableData()
    },
    // 筛选监听
    filterStatusHandler (statusArr) {
      this.type_ids = statusArr.type_ids
      this.setTableData()
    },
    // 状态切换
    handleChangeStatus (row, column, rowColumn) {
      changeStatus({
        id: row.id,
        column: column,
        status: row[rowColumn]
      }).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
        this.setTableData()
      })
    },
    // 添加游戏
    addGame (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addLoading = true
          const storeData = this.addForm
          addGame(storeData).then(res => {
            let { status, message } = res
            if (status === 2000) {
              this.$notify({
                message: message,
                type: 'success',
                offset: 100,
                showClose: false
              })
              this.setTableData()
              this.dialogInfoVisible = false
              this.typeName = ''
              this.new_type.id = 0
              this.$refs[formName].resetFields()
              this.setTypeList()
            } else {
              this.$notify({
                message: message,
                type: 'warning',
                offset: 100,
                showClose: false
              })
            }
            this.addLoading = false
          })
        }
      })
    },
    // 添加类型
    addType () {
      if (!this.typeName) {
        return false
      }
      // 无效id剔除
      this.addForm.type_list.some((item, i) => {
        if (item.id === this.new_type.id) {
          this.addForm.type_list.splice(i, 1)
        }
      })
      this.addForm.type_list.some((item, i) => {
        if (item.id === 0) {
          this.addForm.type_list.splice(i, 1)
        }
      })
      addTypeName({
        name: this.typeName
      }).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.new_type = res.data
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 更改排序
    changeSort (row) {
      storeSort({
        id: row.id,
        sort: row.sort
      }).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
          this.setTableData()
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
          this.setTableData()
        }
      })
    },
    // 打开链接弹窗
    linkDialog (row) {
      this.dialogLinkVisible = true
      getLinkInfo({
        id: row.id
      }).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.linkForm = res.data
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
      this.dialogTitle = '游戏链接'
    },
    // 更改链接信息
    setLink (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.linkLoading = true
          const storeData = this.linkForm
          editLink(storeData).then(res => {
            let {status, message} = res
            if (status === 2000) {
              this.$notify({
                message: message,
                type: 'success',
                offset: 100,
                showClose: false
              })
              this.dialogLinkVisible = false
              this.$refs[formName].resetFields()
            } else {
              this.$notify({
                message: message,
                type: 'warning',
                offset: 100,
                showClose: false
              })
            }
            this.linkLoading = false
          })
        }
      })
    },
    // 图片上传弹窗
    imgDialog (row) {
      this.dialogImgVisible = true
      this.dialogTitle = '游戏图片'
      getImgInfo({
        id: row.id
      }).then(res => {
        let {status, message} = res
        if (status === 2000) {
          let data = res.data
          this.imgInfo.icon_img = data.icon_img
          this.imgInfo.center_img = data.center_img
          this.imgInfo.home_img = data.home_img
          this.imgForm.icon_file_id = data.icon_file_id ? data.icon_file_id : ''
          this.imgForm.center_file_id = data.center_file_id ? data.center_file_id : ''
          this.imgForm.home_file_id = data.home_file_id ? data.home_file_id : ''
          this.imgForm.id = row.id
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 上传前回调
    beforeAvatarUpload (file) {
      const isIMG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2 && file.size > 0
      if (!isIMG) {
        this.$notify({
          message: '上传图片必须为jpg或png 格式!',
          type: 'warning',
          offset: 100,
          showClose: false
        })
      }
      if (!isLt2M) {
        this.$notify({
          message: '上传图片大小不能超过 2MB!',
          type: 'warning',
          offset: 100,
          showClose: false
        })
      }
      return isIMG && isLt2M
    },
    // 上传icon文件，获取文件流
    handleIconChange (file) {
      this.iconFile = file.raw
      this.curr_click_upload_tag = 'icon'
    },
    // 上传icon文件，获取文件流
    handleCenterChange (file) {
      this.centerFile = file.raw
      this.curr_click_upload_tag = 'center'
    },
    // 上传icon文件，获取文件流
    handleHomeChange (file) {
      this.homeFile = file.raw
      this.curr_click_upload_tag = 'home'
    },
    submitUpload () {
      // 创建表单对象
      let position = this.curr_click_upload_tag
      let form = new FormData()
      // 后端接受参数 ，可以接受多个参数
      let file = ''
      switch (position) {
        case 'icon':
          file = this.iconFile
          break
        case 'center':
          file = this.centerFile
          break
        case 'home':
          file = this.homeFile
          break
        default:
          file = ''
          break
      }
      form.append('file', file)
      uploadImg(form).then(res => {
        let {status, message} = res
        if (status === 2000) {
          switch (position) {
            case 'icon':
              this.imgForm.icon_file_id = res.data.file_id
              this.imgInfo.icon_img = res.data.file_path
              break
            case 'home':
              this.imgForm.home_file_id = res.data.file_id
              this.imgInfo.home_img = res.data.file_path
              break
            default:
              this.imgForm.center_file_id = res.data.file_id
              this.imgInfo.center_img = res.data.file_path
              break
          }
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
        this.$refs[position].clearFiles()
      })
    },
    setImg () {
      this.imgLoading = true
      saveGameImg(this.imgForm).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
          this.dialogImgVisible = false
          this.setTableData()
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
        this.imgLoading = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/game/index.vue